<template>
  <ClientRequestsBoard type="RIB" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ClientRequestsBoard from "./ClientRequestsBoard.vue";

export default defineComponent({
  name: "RibRequests",
  components: { ClientRequestsBoard },
});
</script>
